import React, { createContext, useContext, useState, useEffect } from "react";

const AppContext = createContext();

export const BaseUrlProvider = ({ children }) => {

  // const [baseUrl] = useState("http://127.0.0.1:8000/api");
  // const baseUrlForFile = "http://127.0.0.1:8000/storage";

  const [baseUrl, setBaseUrl] = useState(
    "https://breidly.btsportfolio2026.com/backend/public/api",
  );
  const [baseUrlForFile, setBaseUrlForFile] = useState(

    "https://briedly.btsportfolio2026.com/backend/public/storage",
  );

  const [loggedInCustomer, setLoggedInCustomer] = useState(null);
  const [loggedInAdmin, setLoggedInAdmin] = useState(null);

  useEffect(() => {
    const customerData = localStorage.getItem("LoggedInCustomer");

    if (customerData) {
      setLoggedInCustomer(JSON.parse(customerData));
    }
  }, []);

  const usernameRegex = /^[a-zA-Z0-9_]{3,15}$/;
  const emailRegex = /\S+@\S+\.\S+/;
  const passwordRegex = /^.{6,}$/;
  const phoneNumberRegex = /^[0-9]{4}-[0-9]{7}$/;
  const CNICRegex = /^[0-9]{5}-[0-9]{7}-[0-9]{1}$/;
  const eventNameRegex = /^[a-zA-Z0-9\s,'&-]{3,50}$/;
  const guestCountRegex = /^[1-9][0-9]{0,5}$/;
  const budgetRegex =
    /^(PKR\s?)?([0-9]{1,3}(,[0-9]{3})*|[0-9]+)(\.[0-9]{1,2})?$/i;
  const subjectRegex = /^.{3,100}$/;
  const descriptionRegex = /^.{10,500}$/;
  const venueRegex = /^[a-zA-Z0-9\s,'.-]{3,100}$/;
  const fullNameRegex = /^[a-zA-Z\s]{3,50}$/;

  const regexChecker = (type, input) => {
    switch (type) {
      case "username":
        if (!usernameRegex.test(input))
          return "Username must be 3-15 characters";
        break;

      case "email":
        if (!emailRegex.test(input)) return "Invalid Email";
        break;

      case "password":
        if (!passwordRegex.test(input))
          return "Password must be at least 6 characters";
        break;

      case "phoneNumber":
        if (!phoneNumberRegex.test(input))
          return "Phone number must be in the format: 0300-1234567";
        break;

      case "CNIC":
        if (!CNICRegex.test(input))
          return "CNIC must be in the format: 12345-1234567-1";
        break;

      case "eventName":
        if (!eventNameRegex.test(input))
          return "Event Name must be 3-50 characters";
        break;

      case "guestCount":
        if (!guestCountRegex.test(input))
          return "Guest Count must be a valid number";
        break;

      case "budget":
        if (!budgetRegex.test(input))
          return "Budget must be a valid amount e.g. 150000 or PKR 150,000";
        break;

      case "subject":
        if (!subjectRegex.test(input))
          return "Subject must be 3-100 characters";
        break;

      case "description":
        if (!descriptionRegex.test(input))
          return "Description must be 10-500 characters";
        break;

      case "venue":
        if (!venueRegex.test(input)) return "Venue must be 3-100 characters";
        break;

      case "fullName":
        if (!fullNameRegex.test(input)) return "Name must be 3-50 letters only";
        break;

      default:
        return "";
    }
    return "";
  };

  return (
    <AppContext.Provider
      value={{
        baseUrl,
        baseUrlForFile,
        regexChecker,
        loggedInCustomer,
        setLoggedInCustomer,
        loggedInAdmin,
        setLoggedInAdmin,
      }}
    >
      {children}
    </AppContext.Provider>
  );
};

export const useBaseURL = () => useContext(AppContext);

export default AppContext;
